module.exports = __webpack_public_path__ + "static/img/War.4f33817.png";